module.exports = __webpack_public_path__ + "img/graphql.188c653e.png";